import { Flag32 as Flag } from '@weston/react-world-flags';
import { useTranslation } from 'react-i18next';

import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

const languages = [
  { code: 'en', label: 'English', country: 'GB' },
  { code: 'fr', label: 'Français', country: 'FR' },
  { code: 'zh', label: '中文', country: 'CN' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const handleChangeLanguage = (event: SelectChangeEvent<string>) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <Select value={i18n.language} onChange={handleChangeLanguage}>
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <Flag
                code={lang.country}
                style={{ width: 24, height: 16, marginRight: 8 }}
              />
              {lang.label}
            </span>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
